import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseFederalLotteriesProps<T> = {
  filters?: {
    page?: number
  }
  mapper?: (data: any) => T
}

export const useFederalLotteries = <T,>({
  filters: { page } = {},
  mapper = Mapper.default<T>(),
}: UseFederalLotteriesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['federalLotteriesContests', page],
    queryFn: () => {
      return privateAxios.get('/tmais/federal_lotteries', {
        params: { page },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
